import * as searchTypes from './types'
import * as searchActions from './actions'
import searchReducer from './reducer'

export {searchTypes, searchActions}

export default searchReducer
